exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".lock-open-error-filter-section {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n  margin-bottom: 15px; }\n\n.lock-open-error-filter-dd-w-100 {\n  width: 100%; }\n\n.lock-open-error-branch-search-dd .multiSelect .checkboxLayer {\n  display: inline-block;\n  max-height: 350px !important;\n  overflow-y: auto !important; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/branch_management/components/lock_open_errors/lock_open_errors.scss
// module id = 1001
// module chunks = 1